import { SET_CAP_VALUATION_REDUCER } from '../constants/get_lead_profile.constants';
import {
    GET_LEADS_CAP_MODELS_REQUEST,
    GET_LEADS_CAP_VERSIONS_REQUEST,
    GET_LEADS_CAP_DERIVATIVES_REQUEST,
    GET_LEADS_CAP_REGISTRATION_REQUEST,
    GET_LEADS_CAP_BRANDS_REQUEST_SUCCESS,
    GET_LEADS_CAP_BRANDS_REQUEST_FAILURE,
    GET_LEADS_CAP_DERIVATIVES_REQUEST_SUCCESS,
    GET_LEADS_CAP_DERIVATIVES_REQUEST_FAILURE,
    GET_LEADS_CAP_MODELS_REQUEST_SUCCESS,
    GET_LEADS_CAP_MODELS_REQUEST_FAILURE,
    GET_LEADS_CAP_VERSIONS_REQUEST_SUCCESS,
    GET_LEADS_CAP_VERSIONS_REQUEST_FAILURE,
    GET_LEADS_CAP_REGISTRATION_REQUEST_SUCCESS,
    GET_LEADS_CAP_REGISTRATION_REQUEST_FAILURE,
    GET_LEADS_CAP_VALUATION_REQUEST,
    GET_LEADS_CAP_VALUATION_REQUEST_SUCCESS,
    GET_LEADS_CAP_VALUATION_REQUEST_FAILURE,
} from '../constants/cap.constants';

const initialState = {
    loading: false,
    cap_valuation: null,
    cap_valuation_history: null,
    capBrands: [],
    capDerivatives: [],
    capModels: [],
    capVersions: [],
    capRegistration: [],
    error: null,
};

export const Lead_cap_valuation = (state = initialState, action) => {
    switch (action.type) {
    case SET_CAP_VALUATION_REDUCER:
        return {
            ...state,
            cap_valuation: action.payload.cap_valuation,
            cap_valuation_history: action.payload.cap_valuation_history,
        };
    case GET_LEADS_CAP_MODELS_REQUEST:
        return {
            ...state,
            capModels: [],
        };
    case GET_LEADS_CAP_VERSIONS_REQUEST:
        return {
            ...state,
            capVersions: [],
        };
    case GET_LEADS_CAP_DERIVATIVES_REQUEST:
        return {
            ...state,
            capDerivatives: [],
        };
    case GET_LEADS_CAP_REGISTRATION_REQUEST:
        return {
            ...state,
            capRegistration: [],
        };
    case GET_LEADS_CAP_BRANDS_REQUEST_SUCCESS:
        return {
            ...state,
            capBrands: action.payload,
        };
    case GET_LEADS_CAP_DERIVATIVES_REQUEST_SUCCESS:
        return {
            ...state,
            capDerivatives: action.payload,
        };
    case GET_LEADS_CAP_MODELS_REQUEST_SUCCESS:
        return {
            ...state,
            capModels: action.payload,
        };
    case GET_LEADS_CAP_VERSIONS_REQUEST_SUCCESS:
        return {
            ...state,
            capVersions: action.payload,
        };
    case GET_LEADS_CAP_REGISTRATION_REQUEST_SUCCESS:
        return {
            ...state,
            capRegistration: action.payload,
        };
    case GET_LEADS_CAP_VALUATION_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_LEADS_CAP_VALUATION_REQUEST_SUCCESS:
        // eslint-disable-next-line no-case-declarations
        const { cap_valuation_history } = state;

        return {
            ...state,
            cap_valuation: action.payload,
            cap_valuation_history:
                !cap_valuation_history || cap_valuation_history?.length === 0 ? [action.payload] : [...cap_valuation_history, action.payload],
            loading: false,
        };
    case GET_LEADS_CAP_BRANDS_REQUEST_FAILURE:
    case GET_LEADS_CAP_DERIVATIVES_REQUEST_FAILURE:
    case GET_LEADS_CAP_MODELS_REQUEST_FAILURE:
    case GET_LEADS_CAP_VERSIONS_REQUEST_FAILURE:
    case GET_LEADS_CAP_REGISTRATION_REQUEST_FAILURE:
    case GET_LEADS_CAP_VALUATION_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/cap_valuation.reducer.js